module.exports = "<p>\r\n  user works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/app/user/user.component.html
// module id = ../../../../../src/app/user/user.component.html
// module chunks = main